import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import DeepTopics from './components/DeepTopics';
import QuoteBand from './components/QuoteBand';
import CommunityPrinciples from './components/CommunityPrinciples';
import HomeFaq from './components/HomeFaq';
import SubmitCta from './components/SubmitCta';

export default function Home() {
  return (
    <div>
      <Hero />
      <FeedSection />
      <DeepTopics />
      <QuoteBand />
      <CommunityPrinciples />
      <HomeFaq />
      <SubmitCta />
    </div>
  );
}